import type { TelemetryPayload } from "../types";
import {
  fmtNumber,
  fmtUptime,
  fmtDurationMs,
  severityForDisk,
  severityForTemp,
} from "../lib/format";
import { Tile } from "./Tile";

interface Props {
  telemetry: TelemetryPayload | null;
  downtimeMs?: number;
}

function tempCaption(c: number | null | undefined): string | undefined {
  if (c == null) return undefined;
  if (c >= 80) return "Critical — thermal limit near";
  if (c >= 65) return "Elevated";
  return "Nominal";
}

function diskCaption(pct: number | null | undefined): string | undefined {
  if (pct == null) return undefined;
  if (pct >= 90) return "Critical — running out";
  if (pct >= 75) return "Filling up";
  return "Healthy";
}

export function Tiles({ telemetry, downtimeMs }: Props) {
  const cpu = telemetry?.cpu_temp_c as number | undefined;
  const disk = telemetry?.disk_used_pct as number | undefined;

  return (
    <div className="tiles">
      <Tile
        label="CPU Temperature"
        value={fmtNumber(cpu, 1)}
        unit="°C"
        severity={severityForTemp(cpu)}
        caption={tempCaption(cpu)}
      />
      <Tile
        label="Disk Used"
        value={fmtNumber(disk, 1)}
        unit="%"
        severity={severityForDisk(disk)}
        caption={diskCaption(disk)}
      />
      <Tile label="Uptime" value={fmtUptime(telemetry?.uptime_sec)} />
      <Tile label="Downtime" value={downtimeMs !== undefined ? fmtDurationMs(downtimeMs) : "—"} />
    </div>
  );
}
